import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { checkStringMatch } from 'routes/Library/helpers';
import { Box, styled } from '@mui/system';
import SearchBar from 'ui/SearchBar/SearchBar';

import AddButton from 'ui/Buttons/AddButton';
import ClientsGrid from './ClientsGrid';
import TransferDashboardUserModal from '../TransferDashboardUser/TransferDashboardUserModal';
import { CreateClientModal } from '../CreateClient/ClientCreation';

const StyBox = styled(Box, {
    name: 'StyBox',
})({
    backgroundColor: 'white',
    padding: '1rem',
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
});

const StyHeader = styled(Box, {
    name: 'StyHeader',
})({
    alignContent: 'center',
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'flex-end',
    margin: '1rem',
    flex: 1,
    flexDirection: 'row',
    alignItems: 'right',
    gap: '15px',
});

type Props = {
    clients: ClientT[];
};

const ClientsGridContainer = ({ clients }: Props) => {
    const { t } = useTranslation();

    const [search, setSearch] = useState<string>('');

    const filteredClients = clients.filter((client) =>
        checkStringMatch(client.name, search),
    );

    const [isTransferModalOpen, setIsTransferModalOpen] = useState(false);
    const [isCreateClientModalOpen, setIsCreateClientModalOpen] =
        useState(false);

    return (
        <>
            <StyBox data-testid="e2e-clients-management">
                <StyHeader>
                    <SearchBar
                        width="15rem"
                        handleChange={setSearch}
                        placeholder={t('support.searchClient')}
                    />
                    <AddButton
                        onClick={() => setIsTransferModalOpen(true)}
                        text={t('support.transferDashboardButtonLabel')}
                    />
                    <AddButton
                        onClick={() => setIsCreateClientModalOpen(true)}
                        text={t('support.createClientButtonLabel')}
                    />
                </StyHeader>
                <ClientsGrid clients={filteredClients} />
            </StyBox>
            <TransferDashboardUserModal
                binds={clients}
                isOpen={isTransferModalOpen}
                onClose={() => setIsTransferModalOpen(false)}
            />
            <CreateClientModal
                isOpen={isCreateClientModalOpen}
                onClose={() => setIsCreateClientModalOpen(false)}
            />
        </>
    );
};

export default ClientsGridContainer;
